import { motion } from 'framer-motion';

export const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'medium',
  onClick, 
  disabled,
  className = '',
  ...props 
}) => {
  const baseClass = variant === 'primary' ? 'btn-primary' : 'btn-secondary';
  const sizeClass = size === 'large' ? 'text-xl px-10 py-4' : '';
  
  return (
    <motion.button
      className={`${baseClass} ${sizeClass} ${className}`}
      whileTap={disabled ? {} : { scale: 0.94, rotate: 0.3 }}
      whileHover={disabled ? {} : { scale: 1.04, y: -2, rotate: -0.6 }}
      transition={{ type: 'spring', stiffness: 320, damping: 18 }}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </motion.button>
  );
};
